import { render, staticRenderFns } from "./ForwardButton.vue?vue&type=template&id=59a2af8e&scoped=true"
import script from "./ForwardButton.vue?vue&type=script&lang=js"
export * from "./ForwardButton.vue?vue&type=script&lang=js"
import style0 from "./ForwardButton.vue?vue&type=style&index=0&id=59a2af8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a2af8e",
  null
  
)

export default component.exports